module.exports = __webpack_public_path__ + "img/badge-communication-silver-darkbg.4faf90c2.svg";